import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const exportAeoMarkdown = unaryRpc({
  name: "exportAeoMarkdown",
  input: z.object({ teamIds: z.array(zExt.objectId()) }),
  output: z.object({ url: z.string(), exportCount: z.number() }),
});
